/* Keep */

import { SET_CURRENCY_CONVERSION } from '../constants';

export const buildCurrencyConversionAction = (currencyConversionData) => {
    return {
        type: SET_CURRENCY_CONVERSION,
        base: currencyConversionData.base,
        rates: currencyConversionData.rates,
    };
};

export default buildCurrencyConversionAction;
